import { IApiNode } from '@cbridge-packages/api';
import { compareStrings } from '@cbridge-utils/object';
import { INode } from './node.interface';

export namespace NodeTranslator {
  export function fromApi(node: IApiNode): INode {
    return {
      nodeId: node.id,
      name: node.name,
      clientSymbolsCount: node.clientSymbolsCount,
      serversCount: node.serversCount,
      streamsCount: node.streamsCount,
      streams: node.streams
        ?.map(({ id: streamId, name }) => ({ streamId, name, group: node.name }))
        .sort((a, b) => compareStrings(a.name, b.name)),
      servers: node.servers
        ?.map(({ id: value, name: label }) => ({ value, label, group: node.name }))
        .sort((a, b) => compareStrings(a.label, b.label)),
    };
  }
}
